// Batch soru sonucunu review kartı için özetler (saf fonksiyon, React'sız test
// edilebilir). Kök kutu correctAnswers anahtarıdır; şıklar kök kutunun SADECE
// sc-Answer<N> container'lı BasicText çocuklarıdır (sc-Question ve
// sc-True/FalseFeedback ŞIK DEĞİLDİR — karta sızmamalı). Doğruluk correctAnswers
// formatına göre (index / index[] / boolean[] / string[] / eşleştirme çifti[])
// işaretlenir.

const stripHtml = (html) =>
  String(html == null ? "" : html)
    .replace(/<[^>]*>/g, " ")
    .replace(/&nbsp;/g, " ")
    .replace(/\s+/g, " ")
    .trim();

// Boşluk yer tutucularını (#----boşluk1----#, {{#1}}, [[blank1]]) review kartında
// okunur "_____" ile değiştir (SADECE modaldeki önizleme; sahneye eklenen kutu
// metnine dokunulmaz).
const cleanBlanks = (s) =>
  String(s == null ? "" : s)
    .replace(/#-+[^#]*-+#/g, "_____")
    .replace(/\{\{#\d+\}\}/g, "_____")
    .replace(/\[\[[^\]]*\]\]/g, "_____")
    .replace(/\s+/g, " ")
    .trim();

// Kök (assessment) kutu id'si: önce correctAnswers anahtarı, yoksa non-BasicText
// pluginId'li ilk kutu.
const findRootBoxId = (q) => {
  const ca = q?.correctAnswers;
  if (ca && typeof ca === "object") {
    const keys = Object.keys(ca);
    if (keys.length) return keys[0];
  }
  const tb = q?.pluginToolbarsById || {};
  return Object.keys(tb).find((id) => tb[id]?.pluginId && tb[id].pluginId !== "BasicText") || "";
};

// Şıkkın (container) sayısal indeksi: "sc-Answer3" → 3; yoksa Infinity.
const answerIndex = (box) => {
  const m = String(box?.container ?? "").match(/^sc-Answer(\d+)$/);
  return m ? parseInt(m[1], 10) : Number.POSITIVE_INFINITY;
};

const isCorrect = (correct, idx) => {
  if (Array.isArray(correct)) {
    if (correct.length && typeof correct[0] === "boolean") return correct[idx] === true;
    return correct.includes(idx);
  }
  if (typeof correct === "number") return correct === idx;
  return false;
};

export default function summarizeQuestion(q, sceneNameById = {}) {
  if (!q || typeof q !== "object") return { text: "", type: "", sceneName: "", answers: [] };
  const boxes = q.boxesById || {};
  const toolbars = q.pluginToolbarsById || {};
  const rootId = findRootBoxId(q);
  const type = toolbars[rootId]?.pluginId || "";
  const correct = q.correctAnswers ? q.correctAnswers[rootId] : undefined;

  // Soru metni: q.questionText, yoksa sc-Question kutusundan. Boşluk tutucuları temizlenir.
  const questionBoxId = Object.keys(boxes).find(
    (id) => boxes[id]?.parent === rootId && boxes[id]?.container === "sc-Question"
  );
  const text = cleanBlanks(q.questionText || stripHtml(toolbars[questionBoxId]?.state?.__text));

  // Şıklar: SADECE sc-Answer<N> container'lı BasicText çocukları (soru + feedback hariç).
  const answerBoxes = Object.keys(boxes)
    .map((id) => ({ id, box: boxes[id] }))
    .filter(
      ({ id, box }) =>
        box?.parent === rootId &&
        toolbars[id]?.pluginId === "BasicText" &&
        answerIndex(box) !== Number.POSITIVE_INFINITY
    )
    .sort((a, b) => answerIndex(a.box) - answerIndex(b.box));

  const textAt = (i) => stripHtml(toolbars[answerBoxes[i]?.id]?.state?.__text);

  let answers;
  if (type === "Matching") {
    // sc-Answer0..k-1 = sol, sc-Answer k..2k-1 = sağ. correct = [[solIdx, sağIdx], ...].
    const half = Math.floor(answerBoxes.length / 2) || 0;
    const pairs = Array.isArray(correct) ? correct : [];
    answers = pairs
      .filter((p) => Array.isArray(p))
      .map(([l, r]) => ({ text: `${textAt(l)} → ${textAt(half + r)}`, correct: false }));
    // Eşleştirme çifti yoksa en azından sol tarafı listele.
    if (!answers.length)
      answers = answerBoxes.slice(0, half).map((_, i) => ({ text: textAt(i), correct: false }));
  } else if (answerBoxes.length === 0 && Array.isArray(correct) && typeof correct[0] === "string") {
    // FillInBlank (gerçek şema): şık kutusu yok; doğru cevap(lar) correctAnswers string[]'inde.
    answers = correct.map((t) => ({ text: cleanBlanks(t), correct: true }));
  } else {
    // DragDrop/Ordering permütasyon → per-şık doğru işareti anlamsız (hepsi false).
    const isPermutation = type === "DragDrop" || type === "Ordering";
    answers = answerBoxes.map((_, idx) => ({
      text: textAt(idx),
      correct: isPermutation ? false : isCorrect(correct, idx),
    }));
  }

  return {
    text,
    type,
    sceneName: sceneNameById[q.navId] || String(q.navId || ""),
    answers,
  };
}
